import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return { password: 'Password is required' };
        }

        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumber = /[0-9]/.test(value);
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);
        const isValidLength = value.length >= 14;

        const isValid = hasUpperCase && hasLowerCase && hasNumber && hasSymbol && isValidLength;

        return isValid
            ? null
            : {
                  password: 'Password must be at least 14 characters long and include uppercase, lowercase, number, and symbol'
              };
    };
}
